import { Component, OnInit } from '@angular/core';
import { ParamContext } from '../shared/service/param.context';
import { HelpService } from '../shared/service/help.service';
import { HELP_MANAGE_STUDIES } from '../app.constants';
import { JhiLanguageService } from '../shared/core-utils';
import { UrlService } from '../shared/service/url.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StudyManagerTreeComponent } from './study-manager-tree.component';
import { NavTab } from '../shared/nav/tab/nav-tab.model';
import { MANAGE_STUDIES_PERMISSIONS } from '../shared/auth/permissions';
import { LoginService } from '../shared/login/login.service';
import { Program } from '../shared/program/model/program';
import { ProgramService } from '../shared/program/service/program.service';
import { AlertService } from '../shared/alert/alert.service';

@Component({
    selector: 'jhi-studies-manager',
    templateUrl: './study-manager.component.html'
})
export class StudyManagerComponent implements OnInit {

    STUDIES_CREATION_PERMISSIONS = [
        ...MANAGE_STUDIES_PERMISSIONS,
        'CREATE_STUDIES'
    ];

    tabs: NavTab[] = [];

    helpLink: string;
    hideSearchTab = false;

    private studyId: number;
    private program: Program;
    private queryParamSubscription: Subscription;

    constructor(public paramContext: ParamContext,
                public helpService: HelpService,
                public jhiLanguageService: JhiLanguageService,
                public urlService: UrlService,
                public modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public router: Router,
                public activatedRoute: ActivatedRoute,
                private loginService: LoginService,
                private alertService: AlertService,
                private programService: ProgramService
    ) {

        this.paramContext.readParams();

        this.queryParamSubscription = this.activatedRoute.queryParams.subscribe((params) => {
            if (params['datasetId']) {
                return;
            }

            this.studyId = parseInt(params['studyId'], 10);
            if (!this.studyId) {
                return;
            }

            if (!this.exists(this.studyId)) {
                this.tabs.push(new NavTab(this.studyId, params['studyName'], true));
            }

            this.setActive(this.studyId);
        });


        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_MANAGE_STUDIES).toPromise().then((response) => {
                if (response.body) {
                    this.helpLink = response.body;
                }
            }).catch((error) => {
            });
        }
    }

    async ngOnInit() {
        await this.programService.getProgramByProgramUUID(this.paramContext.cropName, this.paramContext.programUUID).toPromise().then((response) => {
            this.program = response.body;
        });
    }

    async createStudy() {

        // Get the login details parameters to check if licence validation is enabled.
        const loginPageDetailsObservable = await this.loginService.getLoginPageDetails().toPromise();
        if (loginPageDetailsObservable.isLicenseValidationEnabled) {
            this.loginService.getBVDesignLicense().toPromise().then((data) => {
                if (data && data.length > 0) {
                    const expiry = data[0].expiry;
                    const expiryDays = data[0].expiryDays;

                    if (expiryDays) {
                        if (expiryDays <= 0) {
                            this.alertService.error('study.manager.errors.start-study-no-license');
                        } else {
                            // Go to the Create Study page if BV Licence is not expired.
                            this.urlService.createStudy();
                        }
                    }
                }

            }).catch((response) => {
                this.alertService.error('study.manager.errors.start-study-no-license');
            });
        } else {
            // Go directly to the Create Study page if BV Licence validation is turned off
            this.urlService.createStudy();
        }

    }

    browseStudy($event) {
        $event.preventDefault();

        this.modalService.open(StudyManagerTreeComponent, { modalDialogClass: 'modal-md', backdrop: 'static' }).result.then((studies) => {
            if (studies && studies.length === 1) {
                const study: any = studies[0];
                const studyId: number = study.id;
                if (study.extraParams && study.extraParams.showSummary) {
                    this.router.navigate(['/study-manager/study/' + studyId], { queryParams: { studyId, studyName: study.name } });
                } else {
                    this.urlService.openStudy(studyId, study.name, this.program);
                }
            }
            this.activeModal.close();
        }, () => {
        });
    }

    setActive(studyId: number) {
        this.hideSearchTab = true;

        this.tabs.forEach((tab: NavTab) => {
            tab.active = (tab.id === studyId);
        });
    }

    setSearchTabActive() {
        this.hideSearchTab = false;
        this.studyId = null;
        this.tabs.forEach((tab: NavTab) => tab.active = false);
    }

    closeTab(tab: NavTab) {
        this.tabs.splice(this.tabs.indexOf(tab), 1);
        if (tab.active) {
            this.hideSearchTab = false;
        }

        this.router.navigate(['/study-manager'], { queryParams: {} });
    }

    trackId(index: number, item: NavTab) {
        return item.id;
    }

    private exists(studyId: number) {
        return this.tabs.some((tab: NavTab) => tab.id === studyId);
    }

}
